import { ServiceData } from '../service';
import db from '../index';
import { entityServiceFactory } from '../entityServiceFactory';

export interface ContractsServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<ContractsServiceData>(db, 'contractsService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
